// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"6a0a3737","347":"416b62c1","449":"138366e6","917":"32525066"}[chunkId] + ".chunk.js";
};